import {
    AD_SLOT_RENDER_ENDED,
    AD_SLOT_UNREGISTER,
    AdSlotRenderEndedAction,
    AdSlotUnregisterAction,
} from 'mk2/containers/AdSlot/AdSlot.actions';
import * as React from 'react';
import { all, takeLatest } from 'redux-saga/effects';
import styles from './AdSlotBranding.mscss';

function* brandingRendered({ slotId, event }: AdSlotRenderEndedAction) {
    const slot = document.getElementById(slotId);
    const body = document.body;
    const frame = slot ? slot.querySelector('iframe') : null;

    if (!event.isEmpty && event.size && Array.isArray(event.size) && (!frame || !frame.dataset.miss)) {
        // set page to layout according to the size of creative
        // size '1x1' is returned from prebid line item. In that case we know,
        // Adform is configured to only return branding (2000x1400) creatives
        let layout = {2000: 'branding', 970: 'billboard', 1: 'branding'}[event.size[0]];

        // Seznam ad - always as billboard
        if (frame && frame.dataset.seznam) {
            layout = 'billboard';
        }

        // Cleanup layouts
        if (layout === 'branding') {
            body.classList.add(styles['body--branding']);
            body.classList.remove(styles['body--billboard']);
        } else if (layout === 'billboard') {
            body.classList.remove(styles['body--branding']);
            body.classList.add(styles['body--billboard']);
        }

        if (slot && layout === 'branding') {
            slot.classList.add(styles['AdSlotBranding--branding']);
        }
    } else {
        // reset to normal page layout to normal, we do not have branding
        if (slot) {
            slot.classList.remove(styles['AdSlotBranding--branding']);
        }
        body.classList.remove(styles['body--branding']);
        body.classList.remove(styles['body--billboard']);
    }

    // Manually collapse empty seznam ads
    if (frame && frame.dataset.miss) {
        slot.style.display = 'none';
    }
}

function* brandingUnregistered({ slotId }: AdSlotUnregisterAction) {
    const body = document.body;
    const slot = document.getElementById(slotId);

    if (slot) {
        slot.classList.remove(styles['AdSlotBranding--branding']);
    }
    body.classList.remove(styles['body--branding']);
    body.classList.remove(styles['body--billboard']);
}

export default function* root() {
    yield all([
        takeLatest((action) => action.type === AD_SLOT_RENDER_ENDED && action.slotId.startsWith('mk-branding'), brandingRendered),
        takeLatest((action) => action.type === AD_SLOT_UNREGISTER && action.slotId.startsWith('mk-branding'), brandingUnregistered),
    ]);
}
